<template>
  <div id="app">
    <navigation-menu v-bind:hidden="this.hideMenu"  >
       <router-view ></router-view>
       <router-view slot="other" name="other"></router-view>
    </navigation-menu>
    
  </div>
</template>

<script>
import AccountLogin from "./components/account_components/AccountLogin.vue";
import NavigationMenu from "./components/NavigationMenu.vue";
import { mapGetters } from 'vuex';

export default {
  name: "app",
  components: {
    AccountLogin,
    NavigationMenu
  },
  computed: {
    ...mapGetters(["authData"]),
  },
  methods: {
    setupHeader() {
      if(this.$route.name == 'Login' || this.$route.name == 'AccountLogout' || this.$route.name ==  'AccountValidate' ||  this.$route.name == 'CreateAccount') {
        this.hideMenu = true;
      }
      else {
         if(this.authData.access_token != null) {
           this.hideMenu = false;
         }
         else {
           this.hideMenu = true;
         }
      }
    }
  },
  date() {
    return {
      hideMenu: true
    }
  },
  created() {
    this.setupHeader();
  },
  watch:{
    $route () {
      this.setupHeader();
    }
  } 
};
</script>

<style>

</style>


<style lang="stylus">
  @import './stylus/main.styl';  
  @import './stylus/app.styl';
  body {
    font-family: $body-font-family;
  }

</style>

